import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import { LoggerService } from '../services/logger.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private logger?: LoggerService;
  private injector = inject(Injector);

  handleError(error: unknown): void {
    // Always log to console for local debugging
    console.error(error);

    // Lazy injection to avoid hydration/initialization cycles
    if (!this.logger) {
      try {
        this.logger = this.injector.get(LoggerService);
      } catch {
        console.warn('LoggerService not yet available');
        return;
      }
    }

    this.logger?.logError(error);
  }
}
